var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('draggable',_vm._b({staticClass:"list-group",attrs:{"disabled":!_vm.allows_crud,"group":"test_descriptor","handle":".handle"},model:{value:(_vm.testDescriptors),callback:function ($$v) {_vm.testDescriptors=$$v},expression:"testDescriptors"}},'draggable',_vm.dragOptions,false),[_c('transition-group',{attrs:{"type":"transition","name":"flip-list"}},[_vm._l((_vm.testDescriptors),function(test_descriptor){return _c('div',{key:`test_descriptor-dragable-${test_descriptor.id}-${test_descriptor.test}-${test_descriptor.position}`},[(
              _vm.user &&
              ((test_descriptor.visible_by_evaluatees == true &&
                _vm.user.group_names.includes('ESTUDIANTES')) ||
                (!_vm.user.group_names.includes('ESTUDIANTES') &&
                  ((_vm.preview_evaluation &&
                    test_descriptor.visible_by_evaluatees == true) ||
                    !_vm.preview_evaluation)))
            )?_c('div',{staticClass:"descriptor-card mb-2",class:{
              'print-hide':
                test_descriptor.visible_by_evaluatees == false &&
                (_vm.preview_evaluation ||
                  _vm.nineth_format_written_partial_duoc ||
                  _vm.second_format_written_exam_duoc ||
                  _vm.fourth_format_epe_duoc),
            }},[_c('div',{staticClass:"descriptor-header"},[(_vm.allows_crud)?_c('div',{staticClass:"descriptor-move handle",class:{ 'grabbable-cursor': _vm.allows_crud }},[_c('b-icon',{staticClass:"move-icon",attrs:{"icon":"arrows-expand","scale":"1.3"}})],1):_vm._e(),_c('RenderVHtml',{staticClass:"w-100",attrs:{"content":test_descriptor.title}}),_c('div',{class:{
                  'container-buttons-allow-cruds':
                    _vm.allows_crud || _vm.test.manual_is_valid,
                }},[(
                    (!test_descriptor.is_locked &&
                      _vm.allows_crud &&
                      _vm.user &&
                      !_vm.user.group_names.includes('PROFESORES')) ||
                    (_vm.test.manual_is_valid &&
                      !test_descriptor.is_locked &&
                      !_vm.preview_evaluation &&
                      _vm.user &&
                      !_vm.user.group_names.includes('PROFESORES'))
                  )?_c('ButtonMedium',{attrs:{"tooltip_text":_vm.test.manual_is_valid
                      ? _vm.$t(
                          'evaluations.newEvaluations.entityIsUnlockedAndClosed',
                          {
                            entity: _vm.$getVisibleNames(
                              'evaluations2.testdescriptor',
                              false,
                              'Descriptor'
                            ),
                          }
                        )
                      : _vm.$t('evaluations.newEvaluations.lockEntity', {
                          entity: _vm.$getVisibleNames(
                            'evaluations2.testdescriptor',
                            false,
                            'Descriptor'
                          ),
                        }),"text_button":``,"click_button":() => _vm.changeStateDescriptor(test_descriptor),"icon":'unlock',"variant":'primary',"custom_class":`mr-1`,"disabled_button":_vm.test.manual_is_valid}}):_vm._e(),(
                    (test_descriptor.is_locked &&
                      _vm.allows_crud &&
                      _vm.user &&
                      !_vm.user.group_names.includes('PROFESORES')) ||
                    (_vm.test.manual_is_valid &&
                      test_descriptor.is_locked &&
                      !_vm.preview_evaluation &&
                      _vm.user &&
                      !_vm.user.group_names.includes('PROFESORES'))
                  )?_c('ButtonMedium',{attrs:{"tooltip_text":_vm.test.manual_is_valid
                      ? _vm.$t(
                          'evaluations.newEvaluations.entityIsLockedAndClosed',
                          {
                            entity: _vm.$getVisibleNames(
                              'evaluations2.testdescriptor',
                              false,
                              'Descriptor'
                            ),
                          }
                        )
                      : _vm.$t('evaluations.newEvaluations.unlockEntity', {
                          entity: _vm.$getVisibleNames(
                            'evaluations2.testdescriptor',
                            false,
                            'Descriptor'
                          ),
                        }),"text_button":``,"click_button":() => _vm.changeStateDescriptor(test_descriptor),"icon":'lock',"variant":'primary',"custom_class":`mr-1`,"disabled_button":_vm.test.manual_is_valid}}):_vm._e(),(_vm.allows_crud && !test_descriptor.is_locked)?_c('ButtonMedium',{attrs:{"tooltip_text":_vm.$t('reusable.common.editTooltip', {
                      entity: _vm.$getVisibleNames(
                        'evaluations2.testdescriptor',
                        false,
                        'Descriptor'
                      ),
                    }),"text_button":``,"click_button":() =>
                      _vm.$bvModal.show(
                        `modal-edit-descriptor-${test_descriptor.test}-${test_descriptor.position}-${test_descriptor.id}-${_vm.container_instrument_id}`
                      ),"icon":'square',"variant":'primary',"custom_class":`mr-1`}}):_vm._e(),(_vm.allows_crud && !test_descriptor.is_locked)?_c('ButtonMedium',{attrs:{"tooltip_text":_vm.$t('reusable.common.deleteTooltip', {
                      entity: _vm.$getVisibleNames(
                        'evaluations2.testdescriptor',
                        false,
                        'Descriptor'
                      ),
                    }),"text_button":``,"click_button":() => _vm.askForDeleteDescriptor(test_descriptor.id),"icon":'trash',"variant":'danger',"custom_class":``}}):_vm._e()],1)],1),(test_descriptor.description.trim() != '')?_c('div',{staticClass:"descriptor-body"},[_c('RenderVHtml',{staticClass:"w-100",attrs:{"content":test_descriptor.description}})],1):_vm._e()]):_vm._e(),_c('b-modal',{attrs:{"id":`modal-edit-descriptor-${test_descriptor.test}-${test_descriptor.position}-${test_descriptor.id}-${_vm.container_instrument_id}`,"title":_vm.$t('reusable.common.editTooltip', {
                entity: _vm.$getVisibleNames(
                  'evaluations2.testdescriptor',
                  false,
                  'Descriptor'
                ),
              }),"hide-footer":"","size":"lg","ignore-enforce-focus-selector":"#sidebar-right"}},[_c('TestDescriptorForm',{attrs:{"test_id":_vm.test_id,"position_number":_vm.position_number,"testDescriptor":test_descriptor,"evaluation_criteria_micro_ids":_vm.evaluation_criteria_micro_ids,"evaluation_situations":_vm.evaluation_situations},on:{"closeModal":function($event){return _vm.$bvModal.hide(
                  `modal-edit-descriptor-${test_descriptor.test}-${test_descriptor.position}-${test_descriptor.id}-${_vm.container_instrument_id}`
                )}}})],1)],1)})],2)],1),_c('div',{staticClass:"container-buttons mb-2"},[(
        _vm.allows_crud &&
        _vm.test &&
        !_vm.test.descriptor_creation_is_locked &&
        !_vm.test.manual_is_valid
      )?_c('ButtonMedium',{attrs:{"tooltip_text":``,"text_button":_vm.$t('reusable.common.addTooltip', {
          entity: _vm.$getVisibleNames(
            'evaluations2.testdescriptor',
            false,
            'Descriptor'
          ),
        }),"click_button":() =>
          _vm.$bvModal.show(
            `modal-created-descriptor-${_vm.test_id}-${_vm.position_number}-${_vm.container_instrument_id}`
          ),"icon":'plus',"variant":'primary',"custom_class":``}}):_vm._e()],1),_c('b-modal',{attrs:{"id":`modal-created-descriptor-${_vm.test_id}-${_vm.position_number}-${_vm.container_instrument_id}`,"title":_vm.$t('reusable.common.createTooltip', {
        entity: _vm.$getVisibleNames(
          'evaluations2.testdescriptor',
          false,
          'Descriptor'
        ),
      }),"hide-footer":"","size":"lg","ignore-enforce-focus-selector":"#sidebar-right"}},[_c('TestDescriptorForm',{attrs:{"test_id":_vm.test_id,"position_number":_vm.position_number,"evaluation_criteria_micro_ids":_vm.evaluation_criteria_micro_ids,"order":_vm.testDescriptors.length > 0
          ? _vm.testDescriptors[_vm.testDescriptors.length - 1].order + 1
          : 1,"evaluation_situations":_vm.evaluation_situations},on:{"closeModal":function($event){return _vm.$bvModal.hide(
          `modal-created-descriptor-${_vm.test_id}-${_vm.position_number}-${_vm.container_instrument_id}`
        )}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }